import React, { useState, useRef, useEffect } from 'react';
import LANGUAGES from '../config/languages.json';

export default function LanguageSelect({ value = [], onChange, placeholder = 'Select languages…' }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  const filtered = LANGUAGES.filter(l =>
    l.name.toLowerCase().includes(search.toLowerCase()) ||
    l.code.toLowerCase().includes(search.toLowerCase())
  );

  const toggle = (code) => onChange(value.includes(code) ? value.filter(c => c !== code) : [...value, code]);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      {/* Trigger */}
      <div onClick={() => setOpen(!open)} style={{
        minHeight: 40, padding: '6px 10px', borderRadius: 'var(--radius-sm)', cursor: 'pointer',
        border: `1px solid ${open ? 'var(--accent)' : 'var(--border)'}`,
        background: 'var(--surface)', display: 'flex', flexWrap: 'wrap', gap: 4, alignItems: 'center',
        boxShadow: open ? '0 0 0 3px rgba(59,130,246,0.1)' : 'none',
      }}>
        {value.length === 0 && (
          <span style={{ fontSize: 13, color: 'var(--text-3)' }}>{placeholder}</span>
        )}
        {value.map(code => (
          <span key={code} style={{
            display: 'inline-flex', alignItems: 'center', gap: 3,
            padding: '2px 7px', borderRadius: 4, fontSize: 11, fontWeight: 700,
            background: 'var(--accent-bg)', color: 'var(--accent)',
            fontFamily: 'Space Mono', textTransform: 'uppercase',
            border: '1px solid #BFDBFE',
          }}>
            {code}
            <button onClick={e => { e.stopPropagation(); onChange(value.filter(c => c !== code)); }} style={{
              background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-3)',
              fontSize: 14, padding: 0, lineHeight: 1, marginLeft: 1,
            }}>×</button>
          </span>
        ))}
        <span style={{ marginLeft: 'auto', color: 'var(--text-3)', fontSize: 11, userSelect: 'none' }}>
          {open ? '▲' : '▼'}
        </span>
      </div>

      {/* Dropdown */}
      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, zIndex: 200,
          background: 'var(--surface)', border: '1px solid var(--border)',
          borderRadius: 'var(--radius-sm)', overflow: 'hidden', boxShadow: 'var(--shadow-lg)',
        }}>
          <div style={{ padding: '8px 10px', borderBottom: '1px solid var(--border)' }}>
            <input autoFocus value={search} onChange={e => setSearch(e.target.value)}
              placeholder="Search languages…" className="field"
              style={{ width: '100%', boxSizing: 'border-box', fontSize: 13 }} />
          </div>
          <div style={{ maxHeight: 220, overflowY: 'auto' }}>
            {filtered.length === 0 && (
              <div style={{ padding: '12px 14px', fontSize: 13, color: 'var(--text-3)' }}>No results</div>
            )}
            {filtered.map(l => {
              const sel = value.includes(l.code);
              return (
                <div key={l.code} onClick={() => toggle(l.code)} style={{
                  padding: '8px 12px', cursor: 'pointer', fontSize: 13,
                  display: 'flex', alignItems: 'center', gap: 10,
                  background: sel ? 'var(--accent-bg)' : 'transparent',
                  color: sel ? 'var(--accent)' : 'var(--text)',
                  transition: 'background 0.1s',
                }}
                  onMouseOver={e => !sel && (e.currentTarget.style.background = 'var(--surface2)')}
                  onMouseOut={e => !sel && (e.currentTarget.style.background = 'transparent')}
                >
                  <span style={{ fontFamily: 'Space Mono', fontSize: 11, color: 'var(--text-3)', width: 34, textTransform: 'uppercase' }}>{l.code}</span>
                  <span style={{ flex: 1 }}>{l.name}</span>
                  {sel && <span style={{ color: 'var(--accent)', fontSize: 13 }}>✓</span>}
                </div>
              );
            })}
          </div>
          {value.length > 0 && (
            <div onClick={() => onChange([])} style={{
              padding: '8px 12px', borderTop: '1px solid var(--border)',
              fontSize: 12, color: 'var(--danger)', cursor: 'pointer',
            }}>
              Clear all ({value.length} selected)
            </div>
          )}
        </div>
      )}
    </div>
  );
}
